let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gGeJz")).then(() => parcelRequire('7vWRj'));